import Vue from "vue";
export default class Pagination extends Vue {
  totalPage = null
  pageSize = 10
  currentPage = 0
  loading = false
  finished = false
  refreshing = false
  error = false

  initPage(pageSize, currentPage) {
    this.pageSize = pageSize
    this.currentPage = currentPage || 1
    this.finished = false
  }

  refresh(cb) {
    this.initPage(10, 1)
    this.loading = true
    cb && cb()
  }
  loadMore(cb) {
    this.currentPage++
    if (this.currentPage <= this.totalPage || this.totalPage==null) {
      cb && cb()
    }else{
      this.finished = true
    }
  }
}